export default __webpack_public_path__ + "static/map-tenn-35063c15f54098339c8f4915e85cddd1.png";